import api from '../services/api'

const saveUserEvents = async (event, data, token) => {
  if (event !== 'newMessageTelegram') {
    try {
      if (token) {
        api.defaults.headers.common.Authorization = token
      }
      const payload = data
        ? {
            front: 'porto',
            ...data,
          }
        : { front: 'porto' }
      const version = process.env.REACT_APP_VERSION
      const timestamp = new Date()
      const body = {
        event,
        payload,
        version,
        timestamp,
      }
      await api.post(`/user/events`, body)
    } catch (error) {
      console.log('Error on save log', error)
    }
  }
}

export default saveUserEvents
